import * as React from 'react';
import { getDeptCacheByKey } from './request-cache';
export default function DepartmentValueItem(props) {
    const { items, separator, mokelay, host, style } = props;
    const [departmentCache, setDepartmentCache] = React.useState({});
    console.log(departmentCache);
    React.useEffect(() => {
        const values = items.map((i) => i.value);
        const newCache = {};
        values.forEach((value) => {
            if (departmentCache[value]) {
                newCache[value] = departmentCache[value];
            }
        });
        setDepartmentCache(newCache);
        items.forEach((item) => {
            if (departmentCache[item.value])
                return;
            if (!item.fullName) {
                getDeptCacheByKey({ value: item.value, mokelay, host }).then((res) => {
                    setDepartmentCache((cur) => ({
                        ...cur,
                        [item.value]: res,
                    }));
                });
            }
            else {
                setDepartmentCache((cur) => ({
                    ...cur,
                    [item.value]: item,
                }));
            }
        });
    }, [items]);
    return items.map((i) => departmentCache[i.value]?.label).join(separator);
}
